export const PRIMARY_COLOR = "#108ee9";
